import React, {useMemo} from 'react';
import ProductWidget from '../product-widget/ProductWidget';
import {useProductsContext} from 'contexts/products-context';
import {sortBy} from 'lodash';
import useStyles from './ProductsWidgetStyles';

function ProductsWidget(props) {
  const {products} = useProductsContext();
  const classes = useStyles();

  const orderedProducts = useMemo(
    () => sortBy(products, (product) => product?.WidgetSortOrder ?? 9999),
    [products],
  );
  const availableProducts = orderedProducts?.filter((product) => Boolean(product?.calculation?.CalculationId));

  return (
    <div className={classes.productsWidgetGrid}>
      {availableProducts?.map((product) => (
        <div key={product.ProductId} className={classes.productGridItem}>
          <ProductWidget product={product} />
        </div>
      ))}
    </div>
  );
}

export default ProductsWidget;
